"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M7 4.623C7 3.727 7.743 3 8.658 3h6.684C16.258 3 17 3.727 17 4.623v2.894L12.435 12 17 16.483v2.894A1.641 1.641 0 0115.342 21H8.658A1.642 1.642 0 017 19.377v-2.894L11.565 12 7 7.517V4.623z" }), "Waiting");
//# sourceMappingURL=Waiting.js.map